
import { Component, Vue, Watch } from "vue-property-decorator";
import { IBreadcrumb } from "@/entity/common/breadcrumb.types";
import StudioSelect from "@/UI/components/Store/StudioSelect.vue";
import { checkUserRole } from "@/router/Lib/helper";
import { VisitsStore } from "@/store/modules/Visits";
import { AppStateStore } from "@/store/modules/appState";
import { getStudioId } from "@/UI/lib/state";
import { newVisitS } from "@/UI/pages/visitsNew/Lib/support";

@Component({
    components: { StudioSelect },
    methods: {},
    computed: { checkUserRole }
})

export default class Breadcrumb extends Vue {
    list: IBreadcrumb[] = [];

    breadCrumbClick(val: any) {
        // console.error(Vue.router.currentRoute)
        if (val.link) {
            Vue.router.push({
                name: val.link,
                params: {
                    Studio: getStudioId(this),
                }
            })
        }
    }

    @Watch("$route", { immediate: true })
    onRouteChange(): void {
        if (checkUserRole() === 'owner') {
        this.list = this.$route.meta!.breadcrumb.filter((e: any) => e.userRoleRoute !== 1)
        } else {
            this.list = this.$route.meta!.breadcrumb
        }
    }

    checkIsNotVisitNewDetailAndCreateMode() {
        if (this.$router.currentRoute.params["mode"] === "create" && this.$route.name === "VisitsNewDetail") {
            return false;
        }
        return true;
    }

    get isVisit(): boolean {
        return String(this.$route.name).startsWith('VisitsNew');
    }
    get readonly(): boolean {
        const visit = VisitsStore.visit;
        return !!this.$route.query.readonly || (this.isVisit && !!visit && Number(visit.id) === Number(this.$route.params.id) && Number(visit.status_id) === 5);
    }

    deleteButtonEvent(event: any): void {
        AppStateStore.setDelete(true);
        event.preventDefault();
    }

    closeButtonEvent(event: any): void {
        AppStateStore.setCancel(true);
        event.preventDefault();
    }
    submitButtonEvent(event: any): void {
        AppStateStore.setSubmit(true);
        event.preventDefault();
    }
}
